function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#blocked2_svg__clip0_75_5023)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 13c3.458 0 6.26-2.686 6.26-6S10.459 1 7 1C3.542 1 .74 3.686.74 7S3.541 13 7 13zM2.57 11.246l8.86-8.492m0 8.492L2.57 2.754"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "blocked2_svg__clip0_75_5023"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})));

var SvgBlocked2 = function SvgBlocked2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgBlocked2;